import React from 'react'
import MarketingLinksScreen from './MarketingLinksScreen'
import type { MarketingLinksScreenTexts } from './MarketingLinksScreen'

const TEXTS: MarketingLinksScreenTexts = {
  fallbackTitle: 'Relatórios',
  fallbackDescription:
    'Cadastre relatórios de marketing com título, descrição e link para download.',
  newButton: 'Novo relatório',
  modalCreateTitle: 'Novo relatório',
  modalEditTitle: 'Editar relatório',
  titlePlaceholder: 'Ex.: Relatório mensal de campanhas',
  descriptionPlaceholder: 'Breve descrição do relatório',
  emptyFiltered: 'Nenhum relatório encontrado com os filtros atuais.',
  emptyList: 'Nenhum relatório cadastrado.',
  titleRequired: 'Informe o título do relatório.',
  loadError: 'Erro ao carregar relatórios.',
  saveError: 'Erro ao salvar relatório.',
  deleteError: 'Erro ao excluir relatório.',
  deleteConfirm: (title) => `Excluir o relatório "${title}"?`,
  deleteReason: 'Exclusão pela tela de relatórios',
  logView: (title) => `Visualizou relatório: ${title}`,
  logCreate: (title) => `Criou relatório: ${title}`,
  logUpdate: (title) => `Atualizou relatório: ${title}`,
  logDelete: (title) => `Excluiu relatório: ${title}`,
}

const MarketingRelatorios: React.FC = () => (
  <MarketingLinksScreen
    moduleName="marketing_relatorios"
    kind="relatorio"
    logEntityType="marketing_report"
    texts={TEXTS}
  />
)

export default MarketingRelatorios
